module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8KYEI"))).then(() => parcelRequire('cvs7o'));